import { useParams } from "react-router";
import { useYard } from "./components";
import { YardGeography } from "./yard-geography";
import { YardSettingsSection } from "./yard-settings-section";

/**
 * Découpage géographique step (from screen 903). Buildings and zones are
 * managed through the single nested geography table from screen 904.
 */
export function YardDecoupagePage() {
  const { yardId } = useParams<{ yardId: string }>();
  const numericYardId = Number(yardId);
  const { yard } = useYard(numericYardId);

  return (
    <YardSettingsSection title="Découpage géographique">
      <YardGeography
        yardId={numericYardId}
        inPreparation={yard?.inPreparation ?? false}
      />
    </YardSettingsSection>
  );
}
